// extracted by mini-css-extract-plugin
export default {"spinning":"Spin_spinning__bP7B3","searching":"Spin_searching__yGRu+"};